import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from '@mui/material'
import { connectField } from 'uniforms'
import { BoolFieldProps } from 'uniforms-mui'
import { Markdown } from '../../Markdown'
import { useCiboAutoForm } from './CiboAutoFormContext'
import { ClearButton } from './ClearButton'
import { ValidationMessages } from './ValidationMessages'

export function BooleanRadioInput(props: BoolFieldProps) {
  const { name, value, label, onChange, disabled, required } = props
  const { touch } = useCiboAutoForm()
  const canClear = !disabled && value !== undefined

  return (
    <FormControl fullWidth required={required} disabled={disabled}>
      {label && (
        <FormLabel component="legend">
          <Markdown>{label}</Markdown>
        </FormLabel>
      )}
      <Stack direction="row" alignItems="center">
        <RadioGroup
          row
          name={name}
          value={value === undefined ? '' : value ? 'true' : 'false'}
          onChange={e => {
            const val = e.target.value
            if (val === 'true') onChange(true)
            else if (val === 'false') onChange(false)

            touch(name)
          }}
          onBlur={() => touch(name)}
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={disabled} />
          <FormControlLabel value="false" control={<Radio />} label="No" disabled={disabled} />
        </RadioGroup>

        {canClear && (
          <ClearButton
            tooltipKey="clearButton.selection"
            onClick={() => onChange(undefined)}
            sx={{ marginLeft: 1 }}
          />
        )}
      </Stack>
      <ValidationMessages
        fieldName={props.name}
        error={props.error as { message: string } | undefined}
      />
    </FormControl>
  )
}

export default connectField(BooleanRadioInput)
